import { useContext, useRef, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// @mui
import { Avatar, Box, Divider, IconButton, MenuItem, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
// components
import MenuPopover from '../../components/MenuPopover';

import { UserContext } from '../../context/userContext';
import useAuth from '../../hooks/useAuth';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Trang chủ',
    label_en: 'Home',
    icon: 'eva:home-fill',
    linkTo: '/',
  },
  {
    label: 'Đổi mật khẩu',
    label_en: 'Change Password',
    icon: 'eva:person-fill',
    linkTo: '/change-password',
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const lang = i18n.language;

  const { user } = useContext(UserContext);
  const { logoutUser } = useAuth();

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleLogout = async () => {
    await logoutUser();
    navigate('/login', { replace: 'true' });
  };
  const handleClose = async () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        {user?.avatar.match('https://') || user?.avatar === '' ? (
          // <Avatar src={user?.avatar} alt="photoURL" />
          <Avatar alt={'avatar'} src={`/static/LogoAvatar.png`} />
        ) : (
          <Avatar src={`${process.env.REACT_APP_IMAGE}${user?.avatar}`} alt="photoURL" />
        )}
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.fullname}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            @{user?.username}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} to={option.linkTo} component={RouterLink}>
              {lang === 'vi' ? option.label : option.label_en}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          {t('accountPop.logout')}
        </MenuItem>
      </MenuPopover>
    </>
  );
}
